
import Vue from "vue";
import { mapGetters } from "vuex";
import { UserLevel } from "@/modules/product/enum/UserLevel";

export default Vue.extend({
  name: "TheAuthorisedMenu",
  computed: {
    ...mapGetters("authorisation", ["userLevel"]),
    canNavigateToInformation(): boolean {
      return (
        this.userLevel &&
        [
          UserLevel.Administrator,
          UserLevel.Hexspoor,
          UserLevel.Default,
        ].includes(this.userLevel)
      );
    },
  },
});
